import React, { useRef, useEffect } from "react";
import { init, getInstanceByDom } from "echarts";
import theme from './theme.json';
function KoCharts({ option, settings, loading,events  }) {
  const chartRef = useRef(null);

  useEffect(() => {
    let chart;
    if (chartRef.current !== null) {
      chart = init(chartRef.current, theme, { renderer: 'svg' });
    }

    function resizeChart() {
      chart?.resize();
    }
    window.addEventListener("resize", resizeChart);
    return () => {
      chart?.dispose();
      window.removeEventListener("resize", resizeChart);
    };
  }, [theme]);

  useEffect(() => {
    // Update chart
    if (chartRef.current !== null) {
      const chart = getInstanceByDom(chartRef.current);
      if (chart) {
        chart.on("click", events);
      }
      chart?.setOption(option, settings);
    }
  }, [option, settings, theme,events]);
  useEffect(() => {
    // Update chart
    if (chartRef.current !== null) {
      const chart = getInstanceByDom(chartRef.current);
      loading === true ? chart.showLoading() : chart.hideLoading();
    }
  }, [loading, theme]);

  return (
    <div className="kochart" ref={chartRef}/>
  );
}

export default KoCharts;